import apiCall from 'shared/utils/apiCall';
import firebaseConfig from 'firebaseConfig';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import { getToken, deleteToken } from 'firebase/messaging';
import createAsyncAction from 'shared/utils/createAsyncAction';
import createAction from './';
import * as services from '../services/registerPushToken';


const REGISTER_PUSH_TOKEN = createAsyncAction(createAction('REGISTER_PUSH_TOKEN'));

export const registerPushToken = (messaging) => (dispatch) => {
  dispatch({ type: REGISTER_PUSH_TOKEN.pending });

  return navigator.serviceWorker.ready.then((registration) =>
    getToken(messaging, {
      serviceWorkerRegistration: registration,
      vapidKey: 'BBsh2kLvDOv9JLOGw82tfx0Jm3rCwL4gXA_r8d_5uW21gXGryXKOTi8e-wKEJKxldx6YuJV-3vYBr_w9cz8BBY0',
    })
      .then((token) => {
        if (!token) throw new Error('Cannot get web push token');

        const apiCallParams = {
          mutation: services.REGISTER_PUSH_TOKEN,
          variables: { pushToken: token, appId: firebaseConfig.appId },
          fetchPolicy: 'no-cache',
        };

        return apiCall(apolloClient.mutate, apiCallParams);
      })
      .then(() => dispatch({ type: REGISTER_PUSH_TOKEN.success }))
      .catch((err) => {
        dispatch(errorAction(REGISTER_PUSH_TOKEN.failure, err));
        throw err;
      }),
  );
};
